import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { QuickCreationNav } from './quick-creation/quick-creation.nav';
import { AmplitudeService } from '@fc-core/services/amplitude.service';
import { HeaderFacade } from './header.facade';
import { MatRipple } from '@angular/material/core';

// todo: migrate to overlay [sc-33575]
@Component({
  selector: 'fc-quick-creation-button',
  template: `
    <div
      class="flex flex-row items-center"
      (click)="triggerAnalytics('create_dropdown_opened')"
    >
      <button
        matRipple
        type="button"
        class="relative flex h-36 max-h-36 cursor-pointer items-center rounded-l-lg border-none bg-primary-600 px-12 py-11 text-xs font-medium leading-[14px] text-white capitalize transition-colors duration-300"
        (click)="quickCreationClick()"
      >
        <span class="text-nowrap">{{ quickCreation()?.name }}</span>
      </button>
      <div
        matRipple
        cdkMenuItem
        [cdkMenuTriggerFor]="quickCreationMenu"
        class="flex h-36 max-h-36 cursor-pointer items-center rounded-r-lg border-l border-primary-700 bg-primary-600 px-12 text-white"
      >
        <fc-icon color="white" [size]="20" icon="icon-arrow-drop-down" />
      </div>
    </div>
    <ng-template #quickCreationMenu>
      <div
        cdkMenu
        class="flex flex-col items-start gap-2 z-[9] min-w-[207px] bg-white shadow-xl py-2 border border-grey-200 rounded"
      >
        @for (menu of quickCreationNavs(); track menu) {
          <button
            [cdkMenuTriggerFor]="subMenu"
            cdkMenuItem
            class="flex items-center justify-between w-full p-10 hover:bg-grey-50 cursor-pointer"
          >
            <div class="w-full flex items-center gap-12">
              <fc-icon [icon]="menu.icon" [size]="20" />
              <span>{{ menu.name }}</span>
            </div>
            <fc-icon icon="icon-arrow-right" [size]="20" />
          </button>

          <ng-template #subMenu>
            <div
              cdkMenu
              class="flex flex-col items-start gap-2 z-[9] min-w-[207px] bg-white shadow-xl py-2 border border-grey-200 rounded"
            >
              @for (subMenu of menu.children; track subMenu) {
                <button
                  (click)="quickCreationClick(subMenu)"
                  cdkMenuItem
                  class="flex items-center justify-between w-full p-10 hover:bg-grey-50 cursor-pointer"
                >
                  <div class="w-full flex items-center gap-12">
                    <fc-icon [icon]="subMenu.icon" [size]="20" />
                    <span>{{ subMenu.name }}</span>
                  </div>
                </button>
              }
            </div>
          </ng-template>
        }
      </div>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatRipple, CdkMenu, CdkMenuItem, CdkMenuTrigger, IconComponent],
})
export class QuickCreationButtonComponent {
  store = inject(Store);
  amplitude = inject(AmplitudeService);
  router = inject(Router);
  headerFacade = inject(HeaderFacade);

  quickCreationNavs = this.headerFacade.quickCreationNavs;
  quickCreation = this.headerFacade.quickCreation;

  triggerAnalytics(event: string): void {
    this.amplitude.track(event);
  }

  quickCreationClick(nav?: QuickCreationNav): void {
    this.headerFacade.navigateQuickCreation(nav);
  }
}
